import React, { FormEventHandler, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollLock } from 'components/common/useScrollLock';
import {
  modalClasses,
  textClasses,
  buttonClasses,
} from 'components/common/tailwindClassnames';

type GundiV1ModalProps = {
  helpCenterUrl: string;
  onToggleModal: MouseEventHandler;
};

const GundiV1Modal = ({ helpCenterUrl, onToggleModal }: GundiV1ModalProps) => {
  const { t } = useTranslation();

  useScrollLock(true);

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="fixed inset-0 bg-greyscale-3 opacity-80 transition-colors duration-300"
        onClick={onToggleModal}
      ></div>
      <div className="fixed inset-0 flex items-center justify-center overflow-y-auto p-4">
        <div className="z-20 my-4 flex w-full flex-col overflow-y-auto rounded-lg bg-unlisted-very-light-gray shadow transition-colors duration-300 sm:w-4/5 md:w-2/3 lg:w-1/2 xl:w-1/3">
          <div className="sticky top-0 z-10 flex flex-row-reverse bg-unlisted-very-light-gray transition-colors duration-300">
            <button
              type="button"
              onClick={onToggleModal}
              className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-ui-text-secondary-text transition-colors duration-300 hover:bg-greyscale-9 hover:text-ui-text-primary-text"
              data-modal-hide="authentication-modal"
            >
              <svg
                aria-hidden="true"
                className="h-7 w-7 text-ui-text-primary-text transition-colors duration-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">{t('Close Modal')}</span>
            </button>
          </div>
          <div className="h-full px-4 pb-6 sm:px-6">
            <h2 className="mb-2 text-lg text-ui-text-primary-text transition-colors duration-300 sm:mb-[8px] sm:text-xl md:text-2xl">
              {t('Assistance needed for this Route')}
            </h2>
            <p className="sm:text-md mb-4 text-sm text-ui-text-primary-text transition-colors duration-300 sm:mb-[32px]">
              {t(
                'Integrations with this technology are supported but cannot be configured directly in this portal. For assistance, please visit the Help Center for guidance or contact Support.',
              )}
            </p>
            <div className="mb-2 flex flex-col gap-2 sm:flex-row sm:gap-0">
              <button
                onClick={() => window.open(helpCenterUrl, '_blank')}
                className="mr-0 rounded-sm bg-brand-accent-green px-4 py-2 font-bold text-teal-t10 transition-colors duration-300 hover:bg-ui-cta-primary sm:mr-3"
              >
                {t('Help Center')}
              </button>
              <button
                onClick={() =>
                  window.open(
                    'https://support.earthranger.com/en_US/gundi-getting-help/gundi-contact-us',
                    '_blank',
                  )
                }
                className={buttonClasses.lightGreen}
              >
                {t('Contact Support')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GundiV1Modal;
